<template>
  <div class="sign_all">
    <div class="sign_detail" @click="detailClick">
      签到明细
    </div>
    <div class="sign_score_balance">
      金币余额
    </div>
    <div class="sign_center">
      <div>
        <el-image :src="scoreSrc" class="sign_img"></el-image>
      </div>
      <div class="sign_score">{{ score }}</div>
      <div class="sign_btn" @click="signClick">
        {{singLabel}}
      </div>
    </div>
    <div class="sign_bottom">
      金币可用于好友之间的聊天消耗～
    </div>
  </div>
</template>

<script>
import {Notify} from "vant";

export default {
  // 我的金币
  name: "index",
  data() {
    return {
      scoreSrc: require('@/assets/score/score.png'),
      score: 0,
      singLabel: '签到'
    }
  },

  methods: {
    // 签到操作
    signClick() {
      Notify({
        type: 'success', message: '签到成功',
        onClose: function () {
          alert("重新请求页面")
        }
      });
    },

    // 签到明细
    detailClick() {
      alert("明细")
    }
  }
}
</script>

<style scoped>

.sign_all {
  font-size: 12px;
  margin: 20px;
}

.sign_detail {
  float: right;
  font-weight: bold;
}

.sign_center {
  height: 120px;
  margin-top: 10px;
  display: flex;
  align-items: center;
  position: relative;
}

.sign_img {
  width: 40px;
  height: 40px;
}

.sign_score_balance {
  clear: both;
  font-size: 18px;
  font-weight: bold;
}

.sign_score {
  margin-left: 10px;
  font-size: 30px;
  font-weight: bold;
}

.sign_btn {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: 0px;
  border-radius: 50px;
  padding: 3px 10px 3px 10px;
  border: 2px solid #FFB118;
  /*font-weight: bold;*/
  font-size: 16px;
  color: #FFB118;
}

.sign_bottom {
  margin-top: 10px;
  font-size: 13px;
  color: #999999;
}
</style>



// WEBPACK FOOTER //
// src/view/pomelo/app/score/index.vue